import * as angular from 'angular';
import './messagesLog.scss';
import MessageNotificationsView from './MessageNotificationsView.html';
import { MessageNotificationsController } from './MessageNotificationsController';
import { MessagesFeatures } from './MessagesFeatures';
const MESSAGES_TAKE = 30;
const MESSAGE_LOGS_SWITCH_TOGGLED_TRACKING = 'message-logs-switch-toggled';
export class MessagesLogController {
    static $inject = ['$scope', '$window', '$translate', 'ngToast', 'LoadingService', 'ApplicationService2', 'MessageService', 'ModalService', 'application', 'BuilderSegmentService', 'LogConfigurationsService', 'BlipToastService', 'SegmentService'];
    constructor($scope, $window, $translate, ngToast, LoadingService, ApplicationService2, MessageService, ModalService, application, BuilderSegmentService, LogConfigurationsService, BlipToastService, SegmentService) {
        'ngInject';
        this.$scope = $scope;
        this.$window = $window;
        this.$translate = $translate;
        this.ngToast = ngToast;
        this.LoadingService = LoadingService;
        this.ApplicationService2 = ApplicationService2;
        this.MessageService = MessageService;
        this.ModalService = ModalService;
        this.application = application;
        this.BuilderSegmentService = BuilderSegmentService;
        this.LogConfigurationsService = LogConfigurationsService;
        this.BlipToastService = BlipToastService;
        this.SegmentService = SegmentService;
        this.onInputChange = (event) => {
            this.search = event.detail.value;
            if (!this.search) {
                this.filter();
            }
        };
        this.onSubmitInput = () => {
            this.filter();
        };
        this.toggleLogsEnabled = async (event) => {
            const checked = event.detail.checked;
            if (this.logsEnabled === checked) {
                return;
            }
            this.LoadingService.startLoading();
            try {
                this.logsEnabled = checked;
                await this.LogConfigurationsService.updateLogConfiguration({
                    enabled: this.logsEnabled,
                });
                this.BlipToastService.show('success', {
                    title: await this.$translate('utils.successMsg.8'),
                    msg: this.logsEnabled
                        ? await this.$translate('modules.application.detail.messages.enabledToast')
                        : await this.$translate('modules.application.detail.messages.disabledAlert.second'),
                });
            }
            catch (e) {
                this.BlipToastService.show('danger', {
                    msg: await this.$translate('utils.errorMsg.10'),
                });
                this.logsEnabled = !this.logsEnabled;
            }
            this.LoadingService.stopLoading();
            this.SegmentService.createTrack(MESSAGE_LOGS_SWITCH_TOGGLED_TRACKING, {
                checked,
            });
        };
        this.loading = LoadingService.isLoadingGlobal;
        this.search = '';
        this.isLoadingMore = false;
        this.messages = [];
        this.noMessages = true;
        this.lastMessage = undefined;
        this.noMoreMessages = false;
        this.newMessages = [];
        this.hasNewMessages = false;
        // scroll detection for new messages
        const onScrollListener = this._onScroll.bind(this, true);
        angular.element($window).on('scroll', onScrollListener);
        // cleanup events and intervals after scope 'destroy' event
        $scope.$on('$destroy', () => {
            angular.element($window).off('scroll', onScrollListener);
        });
        this.query();
    }
    async $onInit() {
        await this.checkFeatures();
        if (this.switchLogsEnabled) {
            await this.checkLogsEnabled();
        }
    }
    async checkFeatures() {
        try {
            this.searchLogsEnabled = await MessagesFeatures.isSearchLogsEnabled();
            this.switchLogsEnabled = await MessagesFeatures.isSwitchLogsEnabled();
        }
        catch (e) {
            console.error(e);
        }
    }
    async checkLogsEnabled() {
        try {
            const logConfigurations = await this.LogConfigurationsService.getLogConfigurations();
            this.logsEnabled = logConfigurations.enabled;
        }
        catch (e) {
            const error = JSON.parse(e);
            if (error.reason.code !== 67) {
                this.BlipToastService.show('danger', {
                    msg: await this.$translate('utils.errorMsg.148'),
                });
            }
        }
    }
    /**
     * Load latest messages up to MESSAGES_TAKE and replace current messages on
     * screen with those loaded.
     *
     * @return {Promise<Array<Message>>} loaded messages
     */
    async query() {
        this.LoadingService.startLoading();
        try {
            // reset state
            this.lastMessage = undefined;
            this.noMoreMessages = false;
            this.newMessages = [];
            this.hasNewMessages = false;
            const messages = await this.MessageService.getMessages(this.application, {
                take: MESSAGES_TAKE,
                contentFilter: this.search,
            });
            this.messages = this.formatMessages(messages);
            this.lastMessage = messages[0];
            // after first load, when search is empty and no messages are shown ==> application has no messages
            this.noMessages = this.search === '' && this.messages.length === 0;
            return messages;
        }
        catch (e) {
            if (e.code == 67) {
                this.messages = [];
            }
            else {
                const errorMsg3 = await this.$translate('utils.errorMsg.3');
                this.ngToast.danger(errorMsg3);
            }
            console.error(e);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    formatMessages(messages) {
        messages.forEach((m) => {
            try {
                if (m.content && m.type && m.type.indexOf('json') >= 0) {
                    m.content = JSON.stringify(m.content, undefined, 2);
                }
                if (m.metadata) {
                    m.metadata = JSON.stringify(m.metadata, undefined, 2);
                }
            }
            catch (e) {
                console.error(e);
            }
        });
        return messages;
    }
    /**
     * Try to load new messages, that is, messages that have been detected
     * after the last message from the last `query`.
     * If new messages are found, they are appended to `newMessages`, and when
     * the user scrolls back to the top, they are appended to `messages`.
     *
     * @return {Promise<Array<Message>>} new messages
     */
    async loadNew() {
        this.LoadingService.startLoading();
        try {
            this.newMessages = [];
            const newMessages = await this.MessageService.getMessages(this.application, {
                take: Math.max(this.messages.length, MESSAGES_TAKE),
                contentFilter: this.search,
            });
            this.hasNewMessages =
                this.hasNewMessages ||
                    (!!this.lastMessage &&
                        newMessages[0].id !== this.lastMessage.id);
            this._onNewMessages(newMessages);
            this._onScroll(false);
            // after reload, when search is empty and no messages are shown ==> application has no messages
            this.noMessages = this.search === '' && this.messages.length === 0;
            return newMessages;
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    /**
     * Attempt to load more messages in an infinite scroll fashion.
     *
     * @return {Promise<Array<Message>>}
     */
    async loadMore() {
        if (this.isLoadingMore) {
            return;
        }
        this.LoadingService.startLoading();
        this.isLoadingMore = true;
        try {
            const messages = await this.MessageService.getMessages(this.application, {
                skip: this.messages.length,
                take: MESSAGES_TAKE,
                contentFilter: this.search,
            });
            this.messages = this.messages.concat(messages);
            this.noMoreMessages =
                messages.length === 0 || messages.length < MESSAGES_TAKE;
            return messages;
        }
        catch (err) {
            this.noMoreMessages = true;
            this.isLoadingMore = false;
        }
        finally {
            this.LoadingService.stopLoading();
            this.isLoadingMore = false;
            this.BuilderSegmentService.trackLogMoreData({ noMoreMessages: this.noMoreMessages }, true);
        }
    }
    /**
     * Load latest messages up to MESSAGES_TAKE based on a search filter on
     * `from` and `to` properties.
     *
     * @param  {String} search search filter
     * @return {Promise<Array<Message>>} messages found
     */
    filter() {
        this.BuilderSegmentService.trackLogSearch({ search: this.search }, true);
        return this.query();
    }
    /**
     * Scroll window to the top and digest angular scope.
     */
    scrollToTop() {
        this.$window.scrollTo(0, 0);
        this._onScroll();
    }
    /**
     * Return channel info based on it's sugarized name.
     *
     * @param  {String} channelName sugarized channel name (@link channels.json)
     * @return {Channel} channel model
     */
    getChannelInfo(channelName) {
        return (this.ApplicationService2.getChannel(channelName, this.application) ||
            {});
    }
    async openMessageNotificationsModal(id) {
        this.LoadingService.startLoading();
        let notifications;
        try {
            notifications = await this.MessageService.getNotifications(id);
        }
        catch (err) {
            console.error(err);
            return;
        }
        finally {
            this.LoadingService.stopLoading();
        }
        const modal = await this.ModalService.showModal({
            template: MessageNotificationsView,
            controller: MessageNotificationsController,
            controllerAs: '$ctrl',
            inputs: {
                notifications: notifications,
            },
        });
        await modal.close;
    }
    /**
     * Called when a window scroll event has been fired.
     * Used to check whether the user is on the top of the page when the flag
     * `hasNewMessages` is on, which should, then, show the new messages and
     * signal the application that the she has read the new messages.
     *
     * @param  {Boolean} digest flag to have angular digest the scope
     */
    _onScroll(digest) {
        if (this.hasNewMessages && this.$window.pageYOffset <= 96) {
            this.messages = this.newMessages;
            this.hasNewMessages = false;
            this.$scope.$emit('messagesRead');
            if (digest) {
                this.$scope.$digest();
            }
        }
    }
    /**
     * Called after a successful result in `loadNew`.
     * Used to count how many new messages have arrived and display it on the page title.
     *
     * @param {Array<Message>} newMessages
     */
    _onNewMessages(newMessages) {
        let count = -1;
        newMessages.some((m) => {
            count++;
            return (!this.lastMessage ||
                (this.lastMessage && m.id === this.lastMessage.id));
        });
        if (count > 0) {
            this.$scope.$emit('newMessages', { count, messages: newMessages });
        }
        this.newMessages = this.formatMessages(newMessages);
        this.lastMessage = newMessages[0];
    }
}
MessagesLogController.$inject = ['$scope', '$window', '$translate', 'ngToast', 'LoadingService', 'ApplicationService2', 'MessageService', 'ModalService', 'application', 'BuilderSegmentService', 'LogConfigurationsService', 'BlipToastService', 'SegmentService'];
